export const specialMenu = {
    crypto: 'Digital Currency',
    virtualCard: 'Virtual Card',
}
export const homeOneModule = {
    title: 'Secure Business Services',
    subTitle: 'Trusted Quality Service',
    descList: [
        {
            content: '10 Years of Experience'
        },
        {
            content: '9 Security Layers'
        },
        {
            content: '8 Service Scenarios'
        },
    ]
}
export const homeTwoModule = {
    title: 'One-stop Global Asset Management',
    subTitle: 'With UBPay, you can manage both stablecoins and fiat currencies on a single platform'
}
export const homeThreeModule = {
    title: 'UBPay: Your Best Global Business Partner',
    subTitle: 'We support instant stablecoin conversions at millisecond-level speed, eliminating the need to switch systems and minimizing market risks'
}
export const homeFourModule = {
    title: 'Fast, Secure, and Efficient Global Virtual Card Services',
    subTitleList: [
        {
            title: 'Fast Card Issuance, Instant Activation',
            subTitle: 'Instantly issue and use cards, saving time and effort',
            img: require('@/assets/imgs/home/gaoxiao.png')
        },
        {
            title: 'Advanced Technology, Strong Security',
            subTitle: 'A reliable technical infrastructure ensures smooth card and transaction processes',
            img: require('@/assets/imgs/home/jishu.png')
        },
        {
            title: 'Multiple Currencies, Convenient Transactions',
            subTitle: 'Offers cards in USD, EUR, GBP, and more to meet various payment needs and reduce currency exchange losses',
            img: require('@/assets/imgs/home/bizhong.png')
        },
    ]
}
export const appDownload = {
    title: 'Download APP',
    desc: 'UBPay is available as a mobile app on iOS and Android',
}
export const footerUbpayDesc = {
    content: 'PACIFIC BANK and EAST BANK jointly established EAST CARD, with its global headquarters in New York and Hong Kong. They have launched UB CARD and UB PAY, with a branch in Singapore. ' +
        'The company has formed strategic partnerships with several international banks to drive the development of payment services in the Asia-Pacific region'
}
export const footerMenu = [
    {
        name: "Products & Services",
        router: "ps",
        childList: [
            {
                name: "Multi-currency Wallet",
                url: "multiWalletAndCcy",
            },
            {
                name: "Stablecoin Conversion",
                url: "transformCcy",
            },
            {
                name: "Virtual Bank Card",
                url: "footerVirtualCard",
            },
            {
                name: "Payment & Withdrawal",
                url: "payment",
            },
            {
                name: "Security",
                url: "security",
            },
        ]
    },
    {
        name: "About Us",
        router: "au",
        childList: [
            {
                name: "About UBPay",
                url: "aboutUbPay",
            },
            {
                name: "Contact Us",
                url: "contactUs",
            }
        ]
    },
    {
        name: "Policies & Regulations",
        router: "pr",
        childList: [
            // {
            //     name: "Terms of Use",
            //     url: "termsOfUse",
            // },
            {
                name: "Privacy Policy",
                url: "privacyPolicy",
            },
            {
                name: "Help Center",
                url: "helpCenter",
            }
        ]
    },
    {
        name: "APP",
        router: "app",
        childList: [
            {
                name: "App Download",
                url: "appDownload",
            }
        ]
    }
]
export const cryptoOneModule = {
    title: 'Supports Multiple Currencies and Chains',
    subTitle: 'We support multiple tokens and chains, allowing you to freely manage digital assets on one platform. Whether Ethereum or TRON, you can switch easily and trade instantly.'
}
export const cryptoTwoModule = {
    title: 'Stablecoin to fiat',
    subTitle: 'UBPay enables instant stablecoin conversion at millisecond speed. No need to switch systems, reducing market volatility risk and protecting asset value.'
}
export const cryptoThreeModule = {
    title: 'A professional team ensures the security of your crypto transactions',
    threeList: [
        {
            content: 'Low fees'
        },
        {
            content: 'Decentralized'
        },
        {
            content: 'Supports multiple chains'
        },
        {
            content: 'Instant settlement'
        },
        {
            content: 'Stablecoin conversion'
        },
        {
            content: 'Reduce fraud risk'
        },
        {
            content: 'Global crypto top-up and withdrawal'
        },
        {
            content: '24/7 customer support'
        },
    ]
}
export const virtualCardOneModule = {
    label: 'Dual network support: Discover & Mastercard',
    title: 'Full coverage of global online spending scenarios, meeting your diverse payment needs',
    subTitleList: [
        {
            img: require('@/assets/imgs/home/gaoxiao2.png'),
            title: "Instant card issuance, real-time arrival",
            content: "No waiting — apply online for a Discover/Mastercard virtual card and start global payments instantly"
        },
        {
            img: require('@/assets/imgs/home/jishu2.png'),
            title: "Advanced Technology, Strong Security",
            content: "A reliable technical infrastructure ensures smooth card and transaction processes"
        },
        {
            img: require('@/assets/imgs/home/bizhong2.png'),
            title: "Multiple Currencies, Convenient Transactions",
            content: "Offers cards in USD, EUR, GBP, and more to meet various payment needs and reduce currency exchange losses"
        },
        {
            img: require('@/assets/imgs/home/baozhang.png'),
            title: "Enjoy full anonymity with top-level privacy",
            content: "Virtual cards offer high anonymity—no real-name ID required, making it easy to issue while protecting your personal privacy."
        }
    ]
}
export const virtualCardTwoModule = {
    title: 'Discover and Mastercard card groups',
    cardGroup: [
        {
            name: 'Discover',
            descList: [
                {
                    content: 'Competitive pricing and smooth experience'
                },
                {
                    content: 'Multi-scenario supported, reusable anytime'
                },
                {
                    content: 'Shared limits for centralized enterprise card control'
                }
            ]
        },
        {
            name: 'Mastercard',
            descList: [
                {
                    content: 'Multi-use support, accepted by a wide range of merchants'
                },
                {
                    content: 'Security and anti-fraud protection'
                },
                {
                    content: 'Responsive customer service'
                }
            ]
        }
    ]
}
export const virtualCardThreeModule = {
    title: 'Instant issuance, easy management',
    openMgtList: [
        {
            title: 'Instant issuance',
            content: 'No waiting — instantly issue Mastercard & Discover virtual cards, ready to use, start spending globally'
        },
        {
            title: 'Multiple currencies supported',
            content: 'Offers cards in USD, EUR, GBP, and more to meet various payment needs and reduce currency exchange losses'
        },
        {
            title: 'Advanced and stable tech',
            content: 'A reliable technical infrastructure ensures smooth card and transaction processes'
        },
        {
            title: 'Easy to manage',
            content: 'Manage multiple cards through the companion app — view and control card details anytime'
        },
        {
            title: 'Global payment capability',
            content: 'Supports major platforms like Alipay and WeChat Pay. Works seamlessly for cross-border e-commerce, overseas shopping, and offline use'
        },
        {
            title: 'Dedicated support, full coverage',
            content: 'Weekday live support for card issues'
        }
    ]
}
export const virtualCardFourModule = {
    title: 'Comprehensive privacy protection',
    privacyAndSecurityList: [
        {
            img: require('@/assets/imgs/home/rq.png'),
            title: "Enjoy full anonymity with top-level privacy",
            content: "Virtual cards offer high anonymity—no real-name ID required, making it easy to issue while protecting your personal privacy."
        },
        {
            img: require("@/assets/imgs/home/aq.png"),
            title: "Secure and reliable, with controllable risk.",
            content: "Each card is issued with a unique number to prevent information leakage. Virtual cards are isolated from your real account, helping protect against fraud during online purchases."
        },
        {
            img: require("@/assets/imgs/home/ed.png"),
            title: "Flexible spending control for smarter usage.",
            content: "Customize top-ups and set spending limits to avoid overspending and reduce risk. No credit check required, making flexible card access available to more users—breaking traditional financial barriers."
        },
    ]
}
export const popup = {
    prContent: {
        regulationsOne: {
            subTitle: '1，Introduction',
            content: 'We values your privacy and is committed to protecting your personal data. This Privacy Policy describes how we collect, use, disclose, and safeguard your information when you visit our website, use our services, or interact with us.'
        },
        regulationsTwo: {
            subTitle: '2，Information We Collect',
            content: 'We may collect the following types of information：',
            list: [
                {
                    content: 'Personal Identification Information (e.g., name, ID number, address, phone number, email)'
                },
                {
                    content: 'Financial Information (e.g., bank account, wallet address, transaction history)'
                },
                {
                    content: 'Technical Data (e.g., IP address, browser type, operating system)'
                },
                {
                    content: 'Usage Data (e.g., login logs, click behavior, preferences)'
                },
                {
                    content: 'KYC Information (Know-Your-Customer documentation)'
                }
            ]
        },
        regulationsThree: {
            subTitle: '3，How We Use Your Information',
            content: 'We use your information to:',
            list: [
                {
                    content: 'Provide, maintain, and improve our services'
                },
                {
                    content: 'Verify your identity and comply with legal obligations'
                },
                {
                    content: 'Process transactions and manage accounts'
                },
                {
                    content: 'Prevent fraud, money laundering, and illicit activities'
                },
                {
                    content: 'Communicate with you regarding service updates and promotions'
                }
            ]
        },
        regulationsFour: {
            subTitle: '4，Sharing and Disclosure',
            content: 'We do not sell your personal data. However, we may share your data with:',
            list: [
                {
                    content: 'Affiliates and service providers under confidentiality agreements'
                },
                {
                    content: 'Regulatory authorities and law enforcement, where required by law'
                },
                {
                    content: 'Business partners for operational or promotional purposes (with your consent)'
                }
            ]
        },
        regulationsFive: {
            subTitle: '5，Data Retention',
            content: 'We retain your personal information only for as long as necessary to fulfill the purposes outlined in this policy or to comply with legal obligations.'
        },
        regulationsSex: {
            subTitle: '6，Data Security',
            content: 'We implement appropriate technical and organizational measures to protect your personal data from unauthorized access, disclosure, alteration, or destruction.'
        },
        regulationsSeven: {
            subTitle: '7，Your Rights',
            content: 'You have the right to:',
            list: [
                {
                    content: 'Access and correct your personal information'
                },
                {
                    content: 'Request deletion or restriction of your data'
                },
                {
                    content: 'Withdraw consent at any time'
                },
                {
                    content: 'File a complaint with a data protection authority'
                }
            ]
        },
        regulationsEight: {
            subTitle: '8，Cookies and Tracking',
            content: 'We use cookies and similar technologies to enhance your experience, analyze site usage, and provide personalized content.'
        },
        regulationsNine: {
            subTitle: '9，International Data Transfers',
            content: 'Your data may be processed and stored in jurisdictions outside of your country. We ensure that appropriate safeguards are in place.'
        },
        regulationsTen: {
            subTitle: '10，Changes to This Policy',
            content: 'We reserve the right to update this Privacy Policy at any time. You will be notified of any significant changes via our website or other means.'
        }
    },
    helpCenterList: [
        {
            title: '1，How to register as a UBPay user?',
            content: 'Download the UBPay app. After opening the app, tap “Register.” You can sign up with your email address. After receiving the verification code, enter it along with your password, agree to the terms, and submit to create your UBPay account.'
        },
        {
            title: '2，Is KYC required to use UBPay?',
            content: 'For digital asset topup, some regions allow use without identity verification. However, applying for a bank card requires KYC. You must submit ID documents (e.g., ID card, passport, or driver’s license). Review time is takes 1–12 hours.'
        },
        {
            title: '3，Can I change my registered email address?',
            content: 'Yes. In the user dashboard, you can update your login email. Enter your new address and verify it via the code sent by email.'
        },
        {
            title: '4，What if I forget my password?',
            content: 'Tap “Forgot Password” on the login page. Enter your email, receive a code, and reset your password. Multiple attempts may trigger security checks.'
        },
        {
            title: '5，Can one person register multiple UBPay accounts?',
            content: 'For risk control reasons, we do not recommend registering multiple UBPay accounts.'
        },
        {
            title: '6，What cards can be applied for?',
            content: 'We offer cards from Mastercard and Discover® Global Network. Both physical and virtual card options are available. Virtual cards can be issued instantly for UBPay users.'
        },
        {
            title: '7，What is a virtual bank card?',
            content: 'A virtual bank card is issued by our partner institutions. It includes a card number, expiry date, and CVV as virtual card. It works like a physical card for online payments but offers greater convenience, anonymity, and security.'
        },
        {
            title: '8，What can the virtual card be used for?',
            content: 'UBPay can be linked to third-party wallets such as Alipay, WeChat Pay, Apple Pay, Google Pay, and PayPal for online payments. They may also be used at select ATMs for cash withdrawal.'
        },
        {
            title: '9，What currencies are supported?',
            content: 'Supported currencies include USD, EUR, and GBP. We also offer multi-currency cards that automatically convert based on transaction location, helping avoid conversion fees.'
        },
        {
            title: '10，How long is a virtual card valid?',
            content: 'UBPay virtual cards are typically valid for 1 to 2 years. After 1 year, they can be renewed for another year. Expiry is shown in the card details.'
        }
    ],
    tfVersionDownloadTitle: 'TF Version Download Guide',
    tfVersionDownload: [
        {
            content: '1，Download TestFlight: Open the App Store on your iOS device, search for “TestFlight,” find the TestFlight app and tap “Get” to download and install.'
        },
        {
            content: '2，Get invitation: The developer will create a public test link or send an invitation email via App Store Connect. Users will receive an email with the invitation link or obtain the link through other channels provided by the developer.'
        },
        {
            content: '3，Invitation link: Click the invitation link, and the system will automatically open the TestFlight app. If it does not open automatically, you can open TestFlight manually.'
        },
        {
            content: '4，Install the app: In the TestFlight app, click the “Start Testing” button, then click the “Install” button. Wait for the app to download and install. Once installation is complete, you can find and open the app from the home screen.'
        }
    ]
}
export const aboutUBPay = {
    title: 'About UBPay',
    content: {
        subTitle: 'UBPay is a fintech company focused on building next-generation digital currency payment systems. We provide secure, efficient, and compliant crypto payment solutions for global users and businesses.',
        content: 'We help businesses enter the digital asset space with cross-border payment freedom, transparent stablecoin settlement, and stable support for high-frequency trading. Our platform supports major public chains like Ethereum and TRON, offering services such as payments, currency exchange, settlement, auto-clearing, and KYC withdrawals — creating future-ready digital payment infrastructure.'
    }
}
export const contactUs = {
    title: 'Contact Us',
    contactEmailMethod: 'Contact us via email',
    contactMediumMethod: 'Our social media',
    contactForm: {
        title: 'Do you need to consult us? Please leave your contact information',
        name: 'Your name',
        email: 'Your email',
        message: 'Your message',
        submit: 'Submit'
    }
}
